import {
  CommandFeedback,
  type CommandFeedbackState,
} from "components/CommandFeedback";
import { commandWording } from "../command-wording";

import type { AdminCommandState } from "./use-admin-command";

// The words come from the command type the state carries, through the one
// exhaustive mapping in commandWording(). There is deliberately no message
// override: a caller that could pass its own words could also forget to.
export function AdminCommandFeedback({
  state,
  onReset,
  testId,
}: {
  state: AdminCommandState;
  onReset: () => void;
  testId?: string;
}) {
  if (state.status === "idle") return null;

  const feedbackState: CommandFeedbackState =
    state.status === "submitting" || state.status === "watching"
      ? { status: "pending" }
      : state;
  // A failed state shows its error, so its words are never rendered.
  const wording =
    state.status === "failed"
      ? { pending: "", success: "" }
      : commandWording(state.type);

  return (
    <CommandFeedback
      state={feedbackState}
      onReset={onReset}
      pendingMessage={wording.pending}
      successMessage={wording.success}
      testId={testId}
    />
  );
}
